import { isDefined } from "@clipboard-health/util-ts";
import { FormControl, InputLabel } from "@mui/material";
import { Input, Title, type UseModalState } from "@src/appV2/redesign/system/ui-components";
import { startOfHour } from "date-fns";
import { useHistory } from "react-router-dom";

import { DigitalClockInputBottomSheet } from "../../DateTime/DigitalClockInputBottomSheet";
import { useInHomeVisitModalsDataContext } from "../../ShiftDiscovery/useInHomeVisitModalsDataContext";
import { BOOKED_VISIT_LOG_DATE_MODAL_PATH } from "../paths";

interface LogVisitStartTimeBottomSheetProps {
  modalState: UseModalState;
  visitDate: Date;
  onConfirm: (date: Date) => void;
}

export function LogVisitStartTimeBottomSheet(props: LogVisitStartTimeBottomSheetProps) {
  const { modalState, visitDate, onConfirm } = props;
  const { visit, generateModalPath } = useInHomeVisitModalsDataContext();
  const history = useHistory();

  const initialTime = startOfHour(new Date());

  return (
    <DigitalClockInputBottomSheet
      modalState={modalState}
      initialTime={initialTime}
      minutesStep={1}
      title={
        <Title component="h5" variant="h5" sx={{ width: "100%", textAlign: "center" }}>
          Log a visit
        </Title>
      }
      subtitle={
        <Title semibold variant="h3" component="h3">
          Select start time
        </Title>
      }
      onConfirm={onConfirm}
      onBack={() => {
        if (!isDefined(visit)) {
          return;
        }

        history.replace(
          generateModalPath(BOOKED_VISIT_LOG_DATE_MODAL_PATH, {
            caseId: visit.attributes.caseId,
            visitId: visit.id,
          })
        );
      }}
    >
      <FormControl fullWidth>
        <InputLabel>Visit Date</InputLabel>
        <Input
          disabled
          aria-hidden="false"
          size="large"
          iconType="calendar-with-cells"
          label="Visit Date"
          value={visitDate.toLocaleDateString()}
        />
      </FormControl>
    </DigitalClockInputBottomSheet>
  );
}
